module.exports = __webpack_public_path__ + "static/img/Testimonial2.9072375.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/Testimonial2.png
// module id = D4Z8
// module chunks = 0